import "./App.css";  
import { Routes, Route} from "react-router-dom";
import SiteNavbar from "./components/SiteNavbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop"; 

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import ChristmasEvent from "./pages/ChristmasEvent";
import RepublicDayEvent from "./pages/RepublicDayEvent";

import AdultPhysiotherapist from "./pages/AdultPhysiotherapist";
import Team from "./pages/Team";

function App() {
  return (
    <>
      <SiteNavbar />
        {/* ✅ Scroll handler */}
      <ScrollToTop />

      {/* Main content */}
      <Routes>
        <Route path="/" element={<Home />} />

        {/* About */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/about/advanced-physiotherapy" element={<AdultPhysiotherapist />}/>
        <Route path="/about/team" element={<Team />} />

        {/* Other pages */}
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/testimonials" element={<Testimonials />} />

         {/* Events */}
        <Route path="/events/christmas" element={<ChristmasEvent />} />
        <Route path="/events/republic-day" element={<RepublicDayEvent />} />
        
        <Route path="/contact" element={<Contact />} />

        {/* Optional redirect if needed */}
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default App;